import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EquipmentCategoryService } from '@app/api/api';
import { environment } from 'environments/environment';
import { debounceTime, map } from 'rxjs/operators';
import { ModalEquipmentCategoryComponent } from '../modal-equipment-category/modal-equipment-category.component';
import { ModalEquipmentTypeComponent } from '../../equipment-type-management/modal-equipment-type/modal-equipment-type.component';

@Component({
  selector: 'meu-equipment-category-management',
  templateUrl: './equipment-category-management.component.html',
  styleUrls: ['./equipment-category-management.component.scss'],
})
export class EquipmentCategoryManagementComponent implements OnInit {
  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private equipmentCategoryService: EquipmentCategoryService
  ) {}

  displayedColumns: string[] = ['Index', 'Image', 'Code', 'Name', 'NameEn', 'Description', 'Actions'];
  lstAll: any = [];
  total: any;
  pageSize = 10;
  pageIndex = 1;
  host: any;
  filter: any = '';
  pageSizeOptions: number[] = [5, 10, 20, 100];

  ngOnInit() {
    this.host = environment.backendhost;
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value) => {
        this.pageIndex = 1;
        this.pageSize = 10;
        this.filter = 'name|code@=*' + value;
        this.getAll();
      });
    this.getAll();
  }

  public keyUp = new Subject<KeyboardEvent>();

  getAll() {
    this.equipmentCategoryService
      .apiEquipmentCategoriesGet(this.filter, '', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.lstAll = res.data.collection;
          this.total = res.data.total;
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAll();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1;
    this.getAll();
  }

  openModal(id) {
    const dialogRef = this.dialog.open(ModalEquipmentCategoryComponent, {
      width: '700px',
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo mới chủng thiết bị thành công');
            this.getAll();
            if (result.category && result.category.id) {
              this.openTypeModal(result.category);
            }
          } else {
            this.toastr.success('Chỉnh sửa chủng thiết bị thành công');
            this.getAll();
          }
        } else {
          this.toastr.error(result.message);
        }
      }
    });
  }

  openTypeModal(category: any) {
    const typeDialogRef = this.dialog.open(ModalEquipmentTypeComponent, {
      width: '700px',
      data: { id: null, preselectedCategory: category },
    });
    typeDialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo mới loại thiết bị thành công');
          } else {
            this.toastr.success('Chỉnh sửa loại thiết bị thành công');
          }
        } else {
          this.toastr.error(result.message);
        }
      }
    });
  }

  deleteItem(ID) {
    const title = 'Xóa chủng thiết bị';
    const description = 'Bạn có chắc chắn muốn xóa chủng thiết bị này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.equipmentCategoryService.apiEquipmentCategoriesIdDelete(ID).subscribe((res) => {
          if (res.success) {
            this.toastr.success('Xoá chủng thiết bị thành công');
            this.getAll();
          } else {
            this.toastr.error(res.message);
          }
        });
      }
    });
  }
}
